// extracted by mini-css-extract-plugin
module.exports = {"nav":"tabbar-in-settings-page_nav__3VNpr"};